<template>
  <v-menu transition="fade-transition" offset-y min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field v-model="field" class="pa-0" v-on="on" v-bind="attrs" :label="label" hide-details readonly clearable @click:clear="$emit('input', '')"></v-text-field>
    </template>
    <v-date-picker color="app-primary" v-model="datePicker" @change="setField"/>
  </v-menu>
</template>

<script>
  import moment from 'moment'
  export default {
    props: ['value', 'label'],

    data: () => ({
      field: '',
      datePicker: moment().format('YYYY-MM-DD'),
    }),

    methods: {
      setField() {
        this.field = moment(this.datePicker, 'YYYY-MM-DD').format('DD/MM/YYYY')
        this.$emit('input', this.datePicker)
      }
    },

    watch: {
      value(val) {
        if (!val)
          this.field = val
      }
      // field(val) {
      //   if (!val)
      //     this.$emit('input', '')
      // }

      // datePicker(val) {
      //   this.field = moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY')
      //   this.$emit('input', val)
      // }
    }
  }
</script>